import type { BlotterOrderEntry } from '@/store/blotter/types/BlotterOrderEntry.ts';
import { getOMSCurrencyFromBlotterCurrency } from '@/store/orders/helpers.ts';
import type { TakeProfitOrder } from '@/store/orders/takeProfitOrder/state.ts';
import type { OrderMode } from '@/store/types.ts';

export const generateTakeProfitOrder = (): TakeProfitOrder => ({
  type: 'TakeProfitOrder',
  clientId: undefined,

  properties: {
    status: { type: 'creating' },
    mode: 'VIEW',
    clockOffset: undefined,
    currencyPair: undefined,
    isReadyToSubmit: false,

    clientWay: 'sell',

    notional: undefined,
    notionalCurrencyIndex: 1,

    limitPrice: undefined,
    customerPrice: undefined,
    commercialMargin: undefined,

    expiry: {
      type: 'GoodTillCancelled',
    },

    notificationEmails: undefined,
  },
});

export const generateTakeProfitOrderFromBlotter = (entry: BlotterOrderEntry, mode: OrderMode): TakeProfitOrder => {
  const currencyPair = getOMSCurrencyFromBlotterCurrency(entry.currencyPair);
  return {
    id: entry.id,
    type: 'TakeProfitOrder',
    clientId: undefined,
    properties: {
      mode,
      currencyPair,
      status: { type: 'submitted', tradeId: entry.id },
      limitPrice: entry.limitPrice,
      expiry: entry.isGtc
        ? { type: 'GoodTillCancelled' }
        : { type: 'ExpiryDate', date: entry.expiryDay ?? undefined, time: entry.expiryTime ?? undefined },
      notificationEmails: undefined,
      isReadyToSubmit: false,
      clientWay: entry.yourWay === 'Buy' ? 'buy' : 'sell',

      notional: entry.notional ?? undefined,
      notionalCurrencyIndex: entry.notionalCurrency === currencyPair?.currency1 ? 1 : 2,

      customerPrice: entry.customerPrice ?? undefined,
      commercialMargin: entry.margin ?? undefined,

      clockOffset: 0,
    },
  };
};

export const isTakeProfitOrder = (order: unknown): order is TakeProfitOrder => {
  return order !== null && typeof order === 'object' && (order as TakeProfitOrder).type === 'TakeProfitOrder';
};
